/*
  Sturdy custom: racquet stringing options widget (Globo Product Options
  replacement). Pairs with snippets/custom-stringing-options.liquid.

  PDP: conditional show/hide, styled dropdowns, add-on total, validation,
  and add-to-cart interception — the racquet is added with visible line item
  properties and the chosen labour tier / string set variants are added as
  component lines linked via _sr_group. The sr-bundle Cart Transform
  function (globo-replacement/sr-bundle-app) merges each group into one
  bundle line at cart/checkout.

  Cart page: reconciles component lines (orphan removal, quantity sync)
  until the Cart Transform function is deployed; harmless no-op after.
*/
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------------------------------------------------------------- PDP */

  // While the Globo app embed is still enabled on this theme, remove its
  // widget so the two don't render or submit together. Harmless once the
  // embed is switched off in Customize → App embeds.
  function removeGlobo() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.gpo-container, .gpo-app, .gpo-hidden-inputs, .gpo-total'),
      function (n) { n.remove(); }
    );
  }

  function initWidget(root) {
    if (root.dataset.srInit) return;
    root.dataset.srInit = '1';

    removeGlobo();
    new MutationObserver(removeGlobo).observe(document.body, { childList: true, subtree: true });

    var form = null;
    if (root.dataset.formId) form = document.getElementById(root.dataset.formId);
    if (!form) {
      var scope = root.closest('.product-info, section, #MainContent') || document;
      form = scope.querySelector('form[data-type="add-to-cart-form"]') ||
             document.querySelector('form[data-type="add-to-cart-form"]');
    }
    var yesValue = root.dataset.yesValue;
    var els = Array.prototype.slice.call(root.querySelectorAll('.sr-el'));
    var totalWrap = root.querySelector('.sr-total');
    var totalOut = root.querySelector('[data-sr-total]');
    var stringSetsLoaded = false;

    function elBySlug(slug) {
      return root.querySelector('.sr-el[data-el="' + slug + '"]');
    }

    function selectedItem(el) {
      return el.querySelector('.sr-dd__item.is-selected');
    }

    function isVisible(el) {
      return !el.hidden;
    }

    function clearError(el) {
      el.classList.remove('has-error');
      var msg = el.querySelector('.sr-msg');
      if (msg) { msg.hidden = true; msg.textContent = ''; }
    }

    function setError(el, text) {
      el.classList.add('has-error');
      var msg = el.querySelector('.sr-msg');
      if (msg) { msg.hidden = false; msg.textContent = text; }
    }

    function addons() {
      var list = [];
      els.forEach(function (el) {
        if (!isVisible(el)) return;
        var item = selectedItem(el);
        if (item && item.dataset.variantId) {
          list.push({
            id: parseInt(item.dataset.variantId, 10),
            priceCents: parseInt(item.dataset.price, 10) // data-price is always integer cents
          });
        }
      });
      return list;
    }

    function update() {
      // visibility rules
      els.forEach(function (el) {
        var rule = el.dataset.showWhen;
        if (!rule) return;
        var idx = rule.indexOf(':');
        var dep = elBySlug(rule.slice(0, idx));
        var want = rule.slice(idx + 1);
        var show = dep && !dep.hidden && dep.dataset.selected === want;
        if (el.hidden === show) {
          el.hidden = !show;
          if (!show) clearError(el);
        }
      });
      // lazy-load string sets when revealed
      var ss = elBySlug('string-set');
      if (ss && !ss.hidden && !stringSetsLoaded) loadStringSets(ss);
      // total
      var sum = addons().reduce(function (a, x) { return a + x.priceCents; }, 0);
      if (totalWrap) {
        totalWrap.hidden = sum === 0;
        if (totalOut) totalOut.textContent = money(sum);
      }
    }

    function choose(el, item) {
      var list = el.querySelector('.sr-dd__list');
      if (list) {
        Array.prototype.forEach.call(list.querySelectorAll('.sr-dd__item.is-selected'), function (n) {
          n.classList.remove('is-selected');
        });
      }
      item.classList.add('is-selected');
      el.dataset.selected = item.dataset.value;
      var valueOut = el.querySelector('.sr-dd__value');
      if (valueOut) valueOut.textContent = item.dataset.value;
      var addonLabel = el.querySelector('[data-addon-label]');
      if (addonLabel) {
        if (item.dataset.price) {
          addonLabel.hidden = false;
          addonLabel.textContent = '(+ ' + money(parseInt(item.dataset.price, 10)) + ')';
        } else {
          addonLabel.hidden = true;
        }
      }
      clearError(el);
      closeAll();
      update();
    }

    function closeAll() {
      Array.prototype.forEach.call(root.querySelectorAll('.sr-dd.open'), function (dd) {
        dd.classList.remove('open');
        var list = dd.querySelector('.sr-dd__list');
        var btn = dd.querySelector('.sr-dd__btn');
        if (list) list.hidden = true;
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.sr-dd__btn');
      if (btn && root.contains(btn)) {
        var dd = btn.closest('.sr-dd');
        var open = dd.classList.contains('open');
        closeAll();
        if (!open) {
          dd.classList.add('open');
          dd.querySelector('.sr-dd__list').hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      var item = e.target.closest('.sr-dd__item');
      if (item && root.contains(item)) {
        choose(item.closest('.sr-el'), item);
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeAll();
    });

    // Tooltip cards: keep them on-screen, and tap-to-toggle for touch devices.
    function fixTipPosition(tip) {
      var content = tip.querySelector('.sr-tip__content');
      if (!content) return;
      content.style.marginLeft = '0px';
      content.style.setProperty('--sr-arrow-x', '50%');
      var rect = content.getBoundingClientRect();
      var pad = 10;
      var shift = 0;
      if (rect.left < pad) shift = pad - rect.left;
      else if (rect.right > window.innerWidth - pad) shift = (window.innerWidth - pad) - rect.right;
      if (shift) {
        content.style.marginLeft = shift + 'px';
        content.style.setProperty('--sr-arrow-x', 'calc(50% - ' + shift + 'px)');
      }
    }
    root.addEventListener('mouseover', function (e) {
      var tip = e.target.closest('.sr-tip');
      if (tip) fixTipPosition(tip);
    });
    root.addEventListener('click', function (e) {
      var tip = e.target.closest('.sr-tip');
      Array.prototype.forEach.call(root.querySelectorAll('.sr-tip.is-open'), function (t) {
        if (t !== tip) t.classList.remove('is-open');
      });
      if (tip) {
        tip.classList.toggle('is-open');
        if (tip.classList.contains('is-open')) fixTipPosition(tip);
      }
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('.sr-radio input[type="radio"]')) {
        var el = e.target.closest('.sr-el');
        el.dataset.selected = e.target.value;
        update();
      }
    });

    function loadStringSets(el) {
      stringSetsLoaded = true;
      fetch(root.dataset.stringSetsUrl)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var list = el.querySelector('.sr-dd__list');
          if (!list) return;
          list.innerHTML = '';
          (data.products || []).forEach(function (p) {
            var v = (p.variants || []).filter(function (x) { return x.available; })[0];
            if (!v) return;
            var cents = Math.round(parseFloat(v.price) * 100); // products.json prices are dollar strings
            var item = document.createElement('div');
            item.className = 'sr-dd__item';
            item.setAttribute('role', 'option');
            item.dataset.value = p.title;
            item.dataset.variantId = String(v.id);
            item.dataset.price = String(cents);
            item.textContent = p.title + ' ';
            var addon = document.createElement('span');
            addon.className = 'addOn';
            addon.textContent = '(+ ' + money(cents) + ')';
            item.appendChild(addon);
            list.appendChild(item);
            if (p.handle === root.dataset.stringSetDefault && !el.dataset.selected) {
              choose(el, item);
            }
          });
          if (!list.children.length) {
            list.innerHTML = '<div class="sr-dd__loading">No string sets in stock right now.</div>';
          }
        })
        .catch(function () {
          stringSetsLoaded = false;
        });
    }

    function validate() {
      var ok = true;
      els.forEach(function (el) {
        if (!isVisible(el) || !('required' in el.dataset)) return;
        var item = selectedItem(el);
        if (!item || !el.dataset.selected) {
          setError(el, 'This field is required');
          if (ok) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          ok = false;
        }
      });
      return ok;
    }

    function properties() {
      var props = {};
      els.forEach(function (el) {
        if (!isVisible(el)) return;
        if (el.dataset.selected) props[el.dataset.cartLabel] = el.dataset.selected;
      });
      return props;
    }

    // Express checkout bypasses the options flow — remove it (Globo parity).
    if (form) {
      var formWrap = form.closest('.product-form-wrapper') || form.parentElement;
      Array.prototype.forEach.call(formWrap.querySelectorAll('.shopify-payment-button'), function (n) {
        n.remove();
      });
    }

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!form || f !== form) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      if (!validate()) return;

      var variantInput = f.querySelector('[name="id"]');
      var qtyInput = f.querySelector('[name="quantity"]');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (!variantId) return;

      var group = Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var comps = addons();
      var props = properties();
      var items = [];

      var parentProps = {};
      Object.keys(props).forEach(function (k) { parentProps[k] = props[k]; });
      if (comps.length) {
        parentProps._sr_group = group;
        parentProps._sr_role = 'parent';
        parentProps._sr_addon_products = JSON.stringify(comps.map(function (c) {
          return { i: String(c.id), q: 1, p: (c.priceCents / 100).toFixed(2) };
        }));
      }
      items.push({ id: variantId, quantity: qty, properties: parentProps });

      comps.forEach(function (c) {
        items.push({
          id: c.id,
          quantity: qty,
          properties: { _sr_group: group, _sr_role: 'component' }
        });
      });

      // Note: f.id is shadowed by the child <input name="id">, so read the attribute.
      var fid = f.getAttribute('id');
      var submitBtns = fid
        ? document.querySelectorAll('[type="submit"][form="' + fid + '"], form[id="' + fid + '"] [type="submit"]')
        : f.querySelectorAll('[type="submit"]');
      Array.prototype.forEach.call(submitBtns, function (b) { b.setAttribute('disabled', 'disabled'); });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          window.location.href = '/cart';
        })
        .catch(function (err) {
          Array.prototype.forEach.call(submitBtns, function (b) { b.removeAttribute('disabled'); });
          var msgBox = f.querySelector('.product-form__error-message');
          var text = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
          if (msgBox) { msgBox.hidden = false; msgBox.textContent = text; } else { alert(text); }
        });
    }, true);

    update();
  }

  /* --------------------------------------------------------- cart page */

  var reconciling = false;

  // Visually group component rows under their racquet and remove their own
  // quantity/remove controls — the racquet line is the single control point.
  function applyCartGrouping(cart) {
    if (!document.getElementById('sr-cart-css')) {
      var st = document.createElement('style');
      st.id = 'sr-cart-css';
      st.textContent =
        '.sr-cart-component>td:first-child>div{margin-left:26px;position:relative;}' +
        '.sr-cart-component>td:first-child>div::before{content:"";position:absolute;left:-16px;top:2px;bottom:2px;width:2px;background:#d9d9d9;border-radius:2px;}' +
        '.sr-cart-component quantity-input,.sr-cart-component .quantity,' +
        '.sr-cart-component cart-remove-button,.sr-cart-component a[href*="/cart/change"],' +
        '.sr-cart-component a[href*="quantity=0"]{display:none!important;}';
      document.head.appendChild(st);
    }
    var parents = {};
    var groups = {};
    (cart.items || []).forEach(function (item) {
      var p = item.properties || {};
      if (!p._sr_group) return;
      if (p._sr_role === 'parent') parents[p._sr_group] = item;
      if (p._sr_role === 'component') (groups[p._sr_group] = groups[p._sr_group] || []).push(item);
    });
    Object.keys(groups).forEach(function (g) {
      var parent = parents[g];
      var pRow = parent && document.getElementById('CartItem-' + parent.key);
      var anchor = pRow;
      groups[g].forEach(function (c) {
        var row = document.getElementById('CartItem-' + c.key);
        if (!row) return;
        row.classList.add('sr-cart-component');
        if (anchor && anchor.parentElement === row.parentElement && anchor.nextElementSibling !== row) {
          anchor.after(row); // slot components directly under their racquet
        }
        if (anchor) anchor = row;
      });
    });
  }

  function reconcileCart() {
    if (reconciling) return;
    reconciling = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        applyCartGrouping(cart);
        var parents = {};
        var components = [];
        (cart.items || []).forEach(function (item) {
          var p = item.properties || {};
          if (!p._sr_group) return;
          if (p._sr_role === 'parent') parents[p._sr_group] = item;
          if (p._sr_role === 'component') components.push(item);
        });
        var updates = {};
        components.forEach(function (c) {
          var parent = parents[c.properties._sr_group];
          if (!parent) {
            updates[c.key] = 0; // orphan — racquet was removed
          } else if (c.quantity !== parent.quantity) {
            updates[c.key] = parent.quantity; // keep qty in lockstep
          }
        });
        if (!Object.keys(updates).length) { reconciling = false; return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () { reconciling = false; });
  }

  function initCartPage() {
    if (window.location.pathname.replace(/\/$/, '') !== '/cart') return;
    reconcileCart();
    var main = document.getElementById('MainContent') || document.body;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(reconcileCart, 900);
    }).observe(main, { childList: true, subtree: true });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.sr-opts'), initWidget);
    initCartPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
